module.exports = __webpack_public_path__ + "img/1691026777398-image.jpg.29d1887b.webp";